// src/subscreens/Home/TeamSection.js
import React from 'react';
import '../../../assets/css/home/TeamSection.css';

const TeamSection = () => {
  const team = [
    {
      name: "Bisma",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=300&h=300&fit=crop"
    },
    {
      name: "Nimra Shahzadi",
      image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=300&h=300&fit=crop"
    },
    {
      name: "Pakeeza Naveed",
      image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=300&h=300&fit=crop"
    }
  ];

  return (
    <section className="ts-team-section py-5">
      <div className="container">
        <div className="row mb-5">
          <div className="col-12 text-center">
            <h2 className="ts-section-title">Our Team</h2>
          
          </div>
        </div>
        <div className="row g-4 justify-content-center">
          {team.map((member, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div className="ts-team-card">
                <div className="ts-team-image-wrapper">
                  <img 
                    src={member.image} 
                    alt={member.name} 
                    className="ts-team-image"
                  />
                </div>
                <h5 className="ts-team-name">{member.name}</h5>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;